import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export function CategoryCard({ category }) {
  return (
    <Link
      to={`/category/${category.slug}`}
      data-testid={`category-card-${category.slug}`}
      className="group relative rounded-xl overflow-hidden border border-border bg-card card-hover"
    >
      <div className="aspect-[4/3] overflow-hidden bg-muted">
        <img
          src={category.image}
          alt={category.name}
          loading="lazy"
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent" />
      <div className="absolute bottom-0 left-0 right-0 p-4 text-white">
        <h3 className="font-serif font-bold text-lg leading-tight">{category.name}</h3>
        <p className="text-xs text-white/80 line-clamp-1 mt-0.5">{category.description}</p>
        <span className="mt-1 inline-flex items-center gap-1 text-xs font-semibold text-primary-foreground/90 group-hover:gap-2 transition-all">
          Shop now <ArrowRight size={13} />
        </span>
      </div>
    </Link>
  );
}
